import { render, staticRenderFns } from "./SatisfactionPerQuestion.vue?vue&type=template&id=44ca7d4a&scoped=true"
import script from "./SatisfactionPerQuestion.vue?vue&type=script&lang=js"
export * from "./SatisfactionPerQuestion.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionPerQuestion.vue?vue&type=style&index=0&id=44ca7d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca7d4a",
  null
  
)

export default component.exports